import { useEffect, useState } from 'react';

const STORAGE_KEY = 'cookie_consent'; // 'accepted' | 'rejected'

export default function CookieConsent() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === 'accepted' || saved === 'rejected') return;
      setOpen(true);
    } catch (e) {
      // si localStorage falla, igual lo mostramos
      setOpen(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch (e) {}
    setOpen(false);
  };

  const reject = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'rejected');
    } catch (e) {}
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[999] p-4 md:p-6">
      <div
        className="
          max-w-5xl mx-auto
          rounded-3xl border border-white/15
          bg-slate-950/80 text-slate-100
          backdrop-blur-xl shadow-2xl
          p-5 md:p-6
          flex flex-col md:flex-row md:items-center gap-4 md:gap-6
        "
        role="region"
        aria-label="Aviso de cookies"
      >
        <div className="flex-1">
          <p className="text-sm md:text-base font-semibold tracking-tight">
            Usamos cookies para mejorar tu experiencia.
          </p>
          <p className="text-xs md:text-sm text-slate-300 mt-1 leading-relaxed">
            Utilizamos herramientas como Google Analytics y Pixel de Meta para analizar el uso del sitio y mejorar el rendimiento.
            Puedes aceptar o rechazar las cookies.
          </p>
        </div>

        <div className="flex items-center gap-3 justify-end">
          <button
            type="button"
            onClick={reject}
            className="
              rounded-2xl px-5 py-3
              text-xs font-black tracking-[0.22em] uppercase
              bg-white/10 hover:bg-white/15 text-white
              border border-white/15
              transition
            "
          >
            Rechazar
          </button>

          <button
            type="button"
            onClick={accept}
            className="
              rounded-2xl px-5 py-3
              text-xs font-black tracking-[0.22em] uppercase
              bg-lime-400 hover:bg-lime-500 text-slate-950
              transition
            "
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}